<template>
    <v-fragment>
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Обратный звонок</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form>
            <div class="modal-body">
                <div class="mb-3">
                    <label for="recipient-name" class="col-form-label">Ваш номер телефона:</label>
                    <MaskInput v-model="phone" class="form-control" id="modal-phone-callback-input"
                               mask="+7 ### ### ## ##"/>

                </div>
            </div>
            <div class="modal-footer">
                <span v-if="success" class="success">{{ message }}</span>
                <span v-if="error" class="danger">{{ message }}</span>
                <button @click.prevent="send" :disabled="progress || !phoneIsCorrect" type="submit"
                        class="btn btn-regular">Отправить
                </button>
                <button type="button" class="btn btn-outline-regular" data-bs-dismiss="modal">Закрыть</button>
            </div>
        </form>
    </v-fragment>
</template>

<script>
export default {
    data: () => ({
        // csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        success: false,
        error: false,
        message: '',
        progress: false,
        phone: '',
    }),

    methods: {
        send() {
            this.success = false;
            this.error = false;
            this.message = '';

            if (this.phoneIsCorrect) {
                this.progress = true;

                let params = {
                    phone: this.getPhone(),
                }

                axios.post('/ajax/callback', params)
                    .then(request => {
                        if (request.data.success) {
                            this.success = true;
                        } else {
                            this.error = true;
                        }

                        this.message = request.data.message;

                        this.progress = false;

                        // Metrika
                        ym(99559018,'reachGoal','CALLBACK')
                    }).catch(reason => {
                        this.error = true;
                        this.message = 'Произошла ошибка';
                        this.progress = false;
                    });
            }
        },
        getPhone() {
            return this.phone.replaceAll(' ', '');
        },
    },

    computed: {
        phoneIsCorrect() {
            return this.getPhone().length === 12;
        }
    },
};
</script>
